<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeUTNK.AmountFrom" :decimal="0" label="Tổng tiền (Min)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeUTNK.AmountTo" :decimal="0" label="Tổng tiền (Max)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeUTNK.FeePercent" :decimal="1" label="Phí UTNK (%)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeUTNK.Cost" :decimal="1" label="Phí gốc (%)" class="input-group--focused"></h-currency-input>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.feeUTNK.loading,
            feeUTNK: state => state.feeUTNK.selected,
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("feeUTNK/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("feeUTNK/setDetail", { data: {
                        ID: 0,
                        AmountFrom: 0,
                        AmountTo: 0,
                        FeePercent: 0,
                        Cost: 0
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("feeUTNK/setDetail", {
                data: this.feeUTNK,
                id: this.feeUTNK.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "FeeUTNKList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
